import { useField } from 'formik';
import type { FC } from 'react';

import { requiredLabel } from '@core/utils/strings';
import { subdivisionLabelFor, subdivisionsFor, withCurrentOption } from '@core/utils/subdivisions';

import { Input } from '../Input/Input';
import { InputDropdown } from '../InputDropdown/InputDropdown';

interface SubdivisionFieldProps {
  /** The address field prefix; this component owns `${name}.state`. */
  name: string;
  /** ISO 3166-1 alpha-2 country the subdivision list should follow. */
  country: string;
  isRequired?: boolean;
}

export const SubdivisionField: FC<SubdivisionFieldProps> = ({
  name,
  country,
  isRequired = false,
}) => {
  const fieldName = `${name}.state`;
  const [field] = useField<string>(fieldName);

  const label = requiredLabel(subdivisionLabelFor(country), isRequired);
  const options = subdivisionsFor(country);

  if (options === null) {
    return <Input name={fieldName} label={label} />;
  }

  // Legacy data ('ONT', 'Ontario') and mid-edit country switches would
  // otherwise render as a blank required field the user can't recover.
  return (
    <InputDropdown
      name={fieldName}
      label={label}
      options={withCurrentOption(options, field.value)}
    />
  );
};
